import React from 'react';

const StatusBadge = ({ tone = '', children }) => (
  <span className={`status-badge ${tone}`.trim()}>
    {children}
  </span>
);

export default StatusBadge;
